import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@uw-env/environment";
import { Observable, map } from "rxjs";
import { ProfileInfoResponse } from "../api/models/profile-info-response";

@Injectable({
  providedIn: "root"
})
export class AdminService {

  constructor(private readonly _client: HttpClient) { }

  getProfile(): Observable<ProfileInfoResponse> {
    const url = `${environment.apiURL}/admin/profile`;
    return this._client.get<{ data: ProfileInfoResponse }>(url).pipe(
      map(res => res.data)
    )
  }

  updateProfile(request: ProfileInfoResponse): Observable<ProfileInfoResponse> {
    const url = `${environment.apiURL}/admin/update/profile`;
    return this._client.post<{ data: ProfileInfoResponse }>(url, request).pipe(
      map(res => res.data)
    )
  }
}